import { render, staticRenderFns } from "./promotionAudit.vue?vue&type=template&id=372a6024&scoped=true&"
import script from "./promotionAudit.vue?vue&type=script&lang=js&"
export * from "./promotionAudit.vue?vue&type=script&lang=js&"
import style0 from "./promotionAudit.vue?vue&type=style&index=0&id=372a6024&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372a6024",
  null
  
)

export default component.exports